@if (state(); as state) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <div class="flex flex-col gap-2.5">
        <div class="flex gap-3 items-center">
          <ui-button
            [iconOnly]="true"
            mode="outlined"
            class="flex-none"
            [routerLink]="['/organizations', organizationId(), 'locations']"
          >
            <ng-icon name="heroArrowLeft" size="20" class="!block" />
          </ui-button>
          <app-page-title class="flex-1">
            @if (state.isLoading) {
              <ui-skeleton class="h-9 w-80 block rounded-full" />
            } @else if (state.data) {
              {{ state.data | formatLocationName }}
            }
          </app-page-title>
        </div>
        <app-location-details-breadcrumb-nav
          [organizationId]="organizationId()"
          [locationId]="locationId()"
        />
      </div>
    </app-page-header>

    @if (!state.error && state.isLoading) {
      <app-nav-skeleton slot="sticky-header" />
    } @else if (state.data) {
      <app-location-details-nav slot="sticky-header" />
    }

    @if (!state.error) {
      <div class="flex flex-col gap-5">
        <div>
          <router-outlet />
        </div>
      </div>
    } @else {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'locations'])"
        class="block"
        style="height: calc(100vh - 5rem - 10rem)"
      />
    }
  </app-organization-sidebar-layout>
}
